import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useListarEmpreendimentos2(enabled?: boolean) {
  const fetchData = async () => {
    const LISTAR_EMPREENDIMENTOS2 = `locais/app-web/empreendimentos2/v1`;
    const response = await instance.get(LISTAR_EMPREENDIMENTOS2);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_empreendimentos2"],
    refetchOnMount: false,
    enabled: enabled ?? false,
  });
  return query;
}
